import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateComponents } from 'src/app/constants/global-constants';

@Component({
  selector: 'app-due-date-calc',
  templateUrl: './due-date-calc.component.html',
  styleUrls: ['./due-date-calc.component.scss']
})
export class DueDateCalcComponent implements OnInit {

  dueDaysDrop :Array<string> ;
  daysBackup : Array<string> = DateComponents.days ;
  months = DateComponents.months;
  years = ['2020', '2021', '2022', '2023', '2024'];
  Days31 = DateComponents.days31;
  Days30 = DateComponents.days30;

  dueForm = new FormGroup({
    dueDay: new FormControl('', Validators.required),
    dueMonth: new FormControl('', Validators.required),
    dueYear: new FormControl('', Validators.required),
  });

  today = new Date();
  progressTitle: Array<string> = ["","","to go"];
  progressPercent: number = 0;
  periodDate: Date = new Date();
  dueDate: Date = new Date();
  dateError: boolean = false;
  weeksPregnant: number;

  constructor(public datepipe: DatePipe) { }

  ngOnInit(): void {
    this.today.setHours(0,0,0,0);
    var date = this.datepipe.transform(this.today, 'yyyy-MM-dd');
    if(date)
    {
      let dateSplit = date.split('-');
      this.dueForm.controls.dueDay.setValue(dateSplit[2]);
      this.dueForm.controls.dueMonth.setValue(dateSplit[1]);
      this.dueForm.controls.dueYear.setValue(dateSplit[0]);
      this.validateDate();
    }
  }

  validateDate(){
    let temp = this.dueForm.controls.dueYear.value + '-' + this.dueForm.controls.dueMonth.value
    + '-' + this.dueForm.controls.dueDay.value;
    this.periodDate = new Date(temp);
    this.periodDate.setHours(0,0,0,0);

    if(this.Days31.includes(this.dueForm.controls.dueMonth.value))
    {
      this.dueDaysDrop = this.daysBackup;
    }
    else if(this.Days30.includes(this.dueForm.controls.dueMonth.value)){
      this.dueDaysDrop = this.daysBackup.slice(0,-1);
    }
    else if(new Date(this.dueForm.controls.dueYear.value+'-02-29').getDate() === 29){
      this.dueDaysDrop = this.daysBackup.slice(0,-2);
    }
    else{
      this.dueDaysDrop = this.daysBackup.slice(0,-3);
    }
    this.dateError = this.periodDate > this.today ? true : false;
  }

  // tslint:disable-next-line:typedef
  calculateDueDate(){
    this.dueDate = this.periodDate;
    this.dueDate.setDate(this.dueDate.getDate() + 280);
    console.log(this.dueDate.getDate());
    const noOfDays = Math.ceil((this.dueDate.getTime() - new Date().getTime())  / (1000 * 3600 * 24));
    this.progressTitle[0] = Math.floor(noOfDays / 7) + ' Weeks';
    this.weeksPregnant = 40 - Math.round(noOfDays / 7);
    this.progressTitle[1] = noOfDays % 7 + ' Days';
    this.progressPercent = noOfDays * 100 / 280;
    this.progressPercent = 100 - this.progressPercent;
    this.progressPercent = this.progressPercent ? this.progressPercent : 1 ;
  }
}
